//src/services/farmer.service.js
import api from './api';

const farmerService = {
  // Get all farmers with pagination and search
  getAllFarmers: async (page = 1, limit = 10, search = '', companyId = null) => {
  try {
    const params = { page, limit };
    if (search) params.search = search;
    if (companyId) params.companyId = companyId;
    const response = await api.get('/farmers', { params });
    return response.data;
  } catch (error) {
    console.error('Error fetching farmers:', error);
    throw error;
  }
},

  // Get farmer by ID
  getFarmerById: async (id) => {
    try {
      const response = await api.get(`/farmers/${id}`);
      return response.data;
    } catch (error) {
      console.error('Error fetching farmer:', error);
      throw error;
    }
  },

  // Create new farmer
  createFarmer: async (farmerData) => {
    try {
      const response = await api.post('/farmers', farmerData);
      return response.data;
    } catch (error) {
      console.error('Error creating farmer:', error);
      throw error;
    }
  },

  // Update farmer
  updateFarmer: async (id, farmerData) => {
    try {
      const response = await api.post(`/farmers/${id}`, farmerData);
      return response.data;
    } catch (error) {
      console.error('Error updating farmer:', error);
      throw error;
    }
  },

  // Delete farmer
  deleteFarmer: async (id) => {
    try {
      const response = await api.delete(`/farmers/${id}`);
      return response.data;
    } catch (error) {
      console.error('Error deleting farmer:', error);
      throw error;
    }
  },


  getFarmers: async (companyId, page = 1, limit = 10, search = '') => {
  const params = { page, limit };
  if (search) params.search = search;
  if (companyId) params.companyId = companyId;
  const res = await api.get('/farmers', { params });
  return res.data;
},

getFarmerCount: async (companyId) => {
  const params = {};
  if (companyId) params.companyId = companyId;
  const res = await api.get('/farmers/count', { params });
  return res.data;
},
  // Add to farmerService object
// getTravelingWithEmployees: async () => {
//   try {
//     const response = await api.get('/farmers/traveling-with/employees');
//     return response.data;
//   } catch (error) {
//     console.error('Error fetching traveling with employees:', error);
//     throw error;
//   }
// },

getTravelingWithEmployees: async (companyId) => {
  const params = {};
  if (companyId) params.companyId = companyId;
  const res = await api.get('/farmers/traveling-with/employees', { params });
  return res.data;
},

getMyHeadquarters: async (companyId) => {
  const params = {};
  if (companyId) params.companyId = companyId;
  const res = await api.get('/farmers/my-headquarters', { params });
  return res.data;
},
};

export default farmerService;